import type * as Types from '../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CurriculumAreasQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CurriculumAreasQuery = { __typename?: 'RootQueryType', curriculumAreas?: { __typename?: 'KeysetPageOfCurriculumArea', results?: Array<{ __typename?: 'CurriculumArea', id: string, name: string }> | null } | null };


export const CurriculumAreasDocument = gql`
    query CurriculumAreas {
  curriculumAreas(sort: [{field: NAME, order: ASC}]) {
    results {
      id
      name
    }
  }
}
    `;

/**
 * __useCurriculumAreasQuery__
 *
 * To run a query within a React component, call `useCurriculumAreasQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurriculumAreasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurriculumAreasQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurriculumAreasQuery(baseOptions?: Apollo.QueryHookOptions<CurriculumAreasQuery, CurriculumAreasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurriculumAreasQuery, CurriculumAreasQueryVariables>(CurriculumAreasDocument, options);
      }
export function useCurriculumAreasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurriculumAreasQuery, CurriculumAreasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurriculumAreasQuery, CurriculumAreasQueryVariables>(CurriculumAreasDocument, options);
        }
// @ts-ignore
export function useCurriculumAreasSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CurriculumAreasQuery, CurriculumAreasQueryVariables>): Apollo.UseSuspenseQueryResult<CurriculumAreasQuery, CurriculumAreasQueryVariables>;
export function useCurriculumAreasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurriculumAreasQuery, CurriculumAreasQueryVariables>): Apollo.UseSuspenseQueryResult<CurriculumAreasQuery | undefined, CurriculumAreasQueryVariables>;
export function useCurriculumAreasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurriculumAreasQuery, CurriculumAreasQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurriculumAreasQuery, CurriculumAreasQueryVariables>(CurriculumAreasDocument, options);
        }
export type CurriculumAreasQueryHookResult = ReturnType<typeof useCurriculumAreasQuery>;
export type CurriculumAreasLazyQueryHookResult = ReturnType<typeof useCurriculumAreasLazyQuery>;
export type CurriculumAreasSuspenseQueryHookResult = ReturnType<typeof useCurriculumAreasSuspenseQuery>;
export type CurriculumAreasQueryResult = Apollo.QueryResult<CurriculumAreasQuery, CurriculumAreasQueryVariables>;